<template>
    <button
        class="btn btn_lg btn_cart btn_icononly"
        v-bind:class="{ active: this.inCart }"
        @click.prevent="inCart ? deleteFromCart(id) : addToCart(id)"
    >
        <i class="f7-icons icon_lg">cart</i>
    </button>
</template>

<script>
export default {
    props: ["id", "qty_per_pack", "qty_in_stock", "title", "sku", "category", "price"],

    computed: {
        inCart() {
            if (this.$store.state.cart.items) {
                return this.$store.state.cart.items.find(
                    (x) => x.id == this.id
                );
            } else {
                return false;
            }
        },
    },

    methods: {
        addToCart() {
            let params = {
                id: this.id,
                qty: this.qty_per_pack,
                title: this.title,
                sku: this.sku,
                category: this.category,
                price: this.price,
            };

            this.$store.dispatch("cart/addToCart", params);
        },

        deleteFromCart() {
            let params = {
                id: this.id,
                // qty: this.qty_per_pack,
                title: this.title,
                sku: this.sku,
                category: this.category,
                price: this.price,
            };

            this.$store.dispatch("cart/deleteFromCart", params);
        },
    },
};
</script>
